export enum PDFGenerated {
  True = "true",
  False = "false",
}
